import {AddressType} from 'desktop/types/addressType';

import {ShippingAddressType, BillingAddressType} from './addressesType';

const DISABLED_STATES = ['California', 'CA'];

const isEnabled = (country: string, state: string) => {
    switch (country) {
        case 'US':
            return !DISABLED_STATES.includes(state);
        default:
            return false;
    }
};

type NarrowAddressType = {
    country: {
        value: string;
    };
    state: {
        value: string;
    };
};

/**
 * Function that determines if autosubscription is enabled for user based on his shipping/billing address
 * @param {Object} addresses - billing and shipping address
 * @param {boolean} isPaypal - if used for paypal
 * @returns {boolean} - returns true if user's locations is enabled for autosubscription to our newsletter
 */
export const autoSubscriptionEnabled = (
    {
        billingAddress,
        shippingAddress,
    }: {
        billingAddress?: BillingAddressType | AddressType | NarrowAddressType;
        shippingAddress?: ShippingAddressType | AddressType | NarrowAddressType;
    },
    isPaypal = false,
): boolean => {
    if (isPaypal && shippingAddress && shippingAddress)
        return isEnabled(shippingAddress.country.value, shippingAddress.state.value);

    if (!billingAddress || !shippingAddress) return false;

    const {
        country: {value: shippingCountry},
        state: {value: shippingState},
    } = shippingAddress;
    const {
        country: {value: billingCountry},
        state: {value: billingState},
    } = billingAddress;

    const isEnabledForShipping = isEnabled(shippingCountry, shippingState);
    const isEnabledForBilling = isEnabled(billingCountry, billingState);

    return isEnabledForShipping && isEnabledForBilling;
};
